"use client"

import { useContext } from "react"
import { PlatformUIKitContext } from "./PlatformUIKitContext"

export function useLinkComponent() {
  const context = useContext(PlatformUIKitContext)
  return context?.linkComponent ?? "a"
}

export function useRadixPortalContainer() {
  const context = useContext(PlatformUIKitContext)
  return context?.radixPortalContainer
}

export function useHydrationSafe() {
  const context = useContext(PlatformUIKitContext)
  return context?.hydrationSafe ?? false
}
